import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as NeuronService from 'services/automata/neuron';

export const useNeuronService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchNeurons = async (options = {}) => {
    const { error, payload } = await NeuronService.read({ ...options, token });

    if (error) {
      toast.error(error);
      return { neurons: [], size: 0 };
    }

    const {
      data: neurons,
      meta: { size }
    } = payload;
    return { neurons, size };
  };

  return { fetchNeurons };
};
